export const CHECKOUT_PARAMS = {
    productId: 'productId',
    success: 'success',
    audacitySuccess: 'audacitySuccess',
    trial: 'trial',
    customCheckout: 'customCheckout',
    flow: 'checkoutFlow',
    prepaidCheck: 'prepaidCheck',
} as const

export const STRIPE_SETUP_RETURN_PARAMS = {
    setupIntent: 'setup_intent',
    setupIntentClientSecret: 'setup_intent_client_secret',
    redirectStatus: 'redirect_status',
} as const

export const CHECKOUT_SUCCESS_PARAMS = [
    CHECKOUT_PARAMS.success,
    CHECKOUT_PARAMS.audacitySuccess,
    CHECKOUT_PARAMS.trial,
    CHECKOUT_PARAMS.customCheckout,
]
